import { Link } from '@remix-run/react'

import { Container, PageHeading, PrimaryButton } from '~/components'

export const ContactSuccessPage = () => {
  return (
    <main className="pb-10 pt-4 md:pb-16">
      <Container className="flex max-w-[844px] flex-col gap-y-10">
        <PageHeading>お問い合わせが完了しました</PageHeading>

        <section>
          <div className="mx-auto flex flex-col justify-start text-body text-textPrimary">
            <p>「officeMAP」をご利用いただき、ありがとうございます。</p>
            <br />
            <p>
              入力していただいたメールアドレス宛に自動返信メールをお送りしました。
            </p>
            <br />
            <p>
              オフィスの運営会社からご連絡いたしますので、しばらくお待ちください。
            </p>
            <br />
            <p className="text-grayText">
              ※自動返信メールが届かない場合は、入力していただいたメールアドレスに誤りがないかご確認のうえ、再度お問い合わせくださいますようお願い申し上げます。
            </p>
          </div>
        </section>

        <Link to="/">
          <PrimaryButton
            className="mx-auto flex h-[52px] w-[220px] items-center justify-center"
            color="brand"
          >
            トップページへ
          </PrimaryButton>
        </Link>
      </Container>
    </main>
  )
}
